// CardContainer.js
import React from 'react';
import './CompetitionCardContainer.css'; // Import the CSS file for styling
import { Link } from 'react-router-dom';


const CompetitionCardContainer = () => {
    const cardsData = [
        {
            title: 'خاطرات سیل خوزستان',
            content: '',
            image: 'CompetitionCard-image1 CompetitionCard-image',
            link: "/sform",
        },
        {
            title: 'خاطرات تشییع',
            content: '',
            image: 'CompetitionCard-image2 CompetitionCard-image',
            link: "/tform",
        },
        {
            title: 'خاطرات با رزمندگان',
            content: '',
            image: 'CompetitionCard-image3 CompetitionCard-image',
            link: "/rform",
        },
    ];

    return (
        <div className="card-container">
            {cardsData.map((card) => (
                <Link to={card.link} className="CompetitionCard" style={{ color: 'inherit', textDecoration: 'none' }}>
                    <div className={card.image}></div>
                    <div className="CompetitionCard-content">
                        <h2 className="CompetitionCard-title">{card.title}</h2>
                        {/* <p className="CompetitionCard-text">{card.content}</p> */}
                    </div>
                </Link>
            ))}
        </div>
    );
};

export default CompetitionCardContainer;
